import React, { ReactNode, useState, FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CurrentTenderBoxContext, UpdateCurrentTenderBoxContext, TenderContext } from './context';
import { useApiTender } from './hooks';
import TenderFullData from '.';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

interface IProps {
  children: ReactNode;
}

export const TenderDataProvider: FC<IProps> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const { data: apiData, loading } = useApiTender(id);
  const allowCustomReport = useFeatureFlag(FeatureFlag.EditableDetailspage);

  const data = useMemo(
    () => (apiData ? new TenderFullData(apiData, { editable: !!allowCustomReport }) : null),
    [allowCustomReport, apiData]
  );
  const contextValue = useMemo(() => ({ data, loading: loading }), [data, loading]);

  return <TenderContext.Provider value={contextValue}>{children}</TenderContext.Provider>;
};

export const CurrentBoxProvider: FC<IProps> = ({ children }) => {
  const [boxId, setBoxId] = useState<string | null>(null);

  return (
    <UpdateCurrentTenderBoxContext.Provider value={setBoxId}>
      <CurrentTenderBoxContext.Provider value={boxId}>{children}</CurrentTenderBoxContext.Provider>
    </UpdateCurrentTenderBoxContext.Provider>
  );
};

export const TenderProvider: FC<IProps> = ({ children }) => {
  return (
    <TenderDataProvider>
      <CurrentBoxProvider>{children}</CurrentBoxProvider>
    </TenderDataProvider>
  );
};
